import React, {Component, PropTypes} from 'react';

import RadioButton from 'patternity/lib/radio_button';
import { Icon } from 'infl-icons';
import { withNamespaces } from 'react-i18next';

class QuizOption extends Component {
  static propTypes = {
    answer: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    isCorrect: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    id: React.PropTypes.string.isRequired
  }

  render() {
    return (
      <div className="c-radio-container" style={this._isCorrect()}>
        {this._renderItem()}
      </div>
    );
  }

  _renderItem = () => {
    const {isEnabled, isSelected, isCorrect, answer, onChange, } = this.props;

    if( !isEnabled && isSelected ){
      return (
        <div className="c-indicator-container" style={{display: 'flex'}}>
          <span
            className={ isCorrect ? 'c-icon-check-wrapper' : 'c-icon-times-wrapper'}
            style={ this._getIconStyle()}>
            <Icon icon={ isCorrect ? 'check' : 'times'}/>
          </span>
          <span className="c-indictor-text" style={{marginLeft:'10px'}}>{answer}</span>
        </div>
      );
    }

    return (
      <label className="c-answer-label"style={{display: 'flex', alignItems:'center'}}>
        <RadioButton
          onChange={onChange}
          radioName={'quiz-answer-' + this.props.id}
          radioLabel={answer}
          value={answer}
          isChecked={isSelected}
          enabled={this.props.isEnabled} />
        { isCorrect && !isSelected && !isEnabled &&
          <span className="c-correct-answer" style={this._correctAnswerStyle}>
            {this.props.t('Correct Answer')}
          </span>
        }
      </label>
    );
  }

  _isCorrect = () => {
    let isCorrectAndSelected = this.props.isCorrect && this.props.isSelected;

    if( !isCorrectAndSelected ){
      return this.styles.answer;
    }

    return {
      ...this.styles.answer,
      backgroundColor: '#eaf5dc', //patternity success lighter colour
      padding: '10px 0px',
      overflow: 'hidden'
    };
  }

  _getIconStyle = () => {
    let style = {
      fontSize: '22px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20px'
    };

    if ( this.props.isCorrect ){
      style.color = '#638e2b'
    }
    else {
      style.color = '#c54040'
    }

    return style;
  }

  _correctAnswerStyle = {
    display: 'inline-block',
    marginLeft: '10px',
    verticalAlign: 'middle',
    color: '#638e2b',
    fontSize: '12px'
  }

  styles = {
    answer: {
      marginBottom: '15px',
      marginLeft: '5px'
    }
  }
}

export default withNamespaces()(QuizOption)



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/components/quiz_option.jsx